import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import { dateToTimezone, empty } from './../../../utils';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

const FormModal = React.memo((props) => {
    if (!props.request || props.request == null) {
        return null;
    }

    const hideHandler = () => {
        props.setIdModal(null);
        props.hideFormModal();
        props.resetRequest();
    };

    let buttonLabel = 'Send Response';
    if (props.sending) {
        buttonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let closeButtonLabel = 'Close Ticket';
    if (props.closingTicket) {
        closeButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let status = null;
    if (parseInt(props.request.status) === 1) {
        status = <i class="fas fa-circle status-open" />;
    } else if (parseInt(props.request.status) === 2) {
        status = <i class="fas fa-circle status-closed" />;
    }

    const renderLog = () => {
        return props.request.log_history.map((logItem) => {
            let type = '';
            if (parseInt(logItem.type) === 1) {
                type = <span className="item-message">Client Message</span>;
            } else if (parseInt(logItem.type) === 2) {
                type = <span className="item-message">ACM Message</span>;
            }

            return (
                <div className="log-item">
                    <span className="item-date">{dateToTimezone(logItem.created_at, 'MM/DD/YYYY')}</span> - {type}: <div dangerouslySetInnerHTML={{ __html: logItem.message.replace(/\n/g, '<br />') }}></div>
                </div>
            );
        });
    };

    const handleSetResponseMessage = (event) => {
        props.setResponseMessage(event.target.value);
    };

    const renderFiles = () => {
        if (empty(props.request.files)) {
            return null;
        }

        const files = JSON.parse(props.request.files);
        if (files.length === 0) {
            return null;
        }

        return (
            <div className="files-container">
                <div><b>Attached Files:</b></div>
                <table className="table table-sm table-hover">
                    <thead>
                        <tr>
                            <th>Filename</th>
                            <th className="actions"></th>
                        </tr>
                    </thead>
                    <tbody>{files.map((file) => {
                        return (
                            <tr>
                                <td>{file.name}</td>
                                <td className="text-center actions">
                                    <Tooltip title="Download File" position="bottom" arrow size="small" className="action-tooltip">
                                        <a href={file.url} target="_blank" rel="noopener noreferrer"><i className="fas fa-download" /></a>
                                    </Tooltip>
                                </td>
                            </tr>
                        );
                    })}</tbody>
                </table>
            </div>
        );
    };

    const renderFittingInformation = () => {
        if (parseInt(props.request.help_with_fitting) === 0) {
            return null;
        }

        let apparelTypes = [];
        if (parseInt(props.request.fitting_apparel_type_scrubs)) {
            apparelTypes.push('Scrubs');
        }
        if (parseInt(props.request.fitting_apparel_type_polos)) {
            apparelTypes.push('Polos');
        }
        if (parseInt(props.request.fitting_apparel_type_jackets)) {
            apparelTypes.push('Jackets');
        }
        if (parseInt(props.request.fitting_apparel_type_other)) {
            apparelTypes.push('Other (' + props.request.fitting_apparel_type_other_description + ')');
        }

        let styles = [];
        if (parseInt(props.request.fitting_style_men)) {
            styles.push('Men');
        }
        if (parseInt(props.request.fitting_style_women)) {
            styles.push('Women');
        }
        if (parseInt(props.request.fitting_style_both)) {
            styles.push('Both');
        }

        let address = [];
        if (props.request.fitting_how_many_people < 5) {
            address = [<div><b>Fitting Location:</b> ACM's office</div>];
        } else {
            address.push(<div><b>Fitting Location Address:</b> {props.request.fitting_address}</div>);
            address.push(<div><b>Fitting Location City:</b> {props.request.fitting_city}</div>);
            address.push(<div><b>Fitting Location State:</b> {props.request.fitting_state}</div>);
            address.push(<div><b>Fitting Location Zip:</b> {props.request.fitting_zip}</div>);

            if (props.request.fitting_department !== '') {
                address.push(<div><b>Fitting Location Department:</b> {props.request.fitting_department}</div>);
            }
            if (props.request.fitting_floor !== '') {
                address.push(<div><b>Fitting Location Floor:</b> {props.request.fitting_floor}</div>);
            }
            address.push(<div><b>Building/Room number:</b> {props.request.fitting_building_number}</div>);
        }

        return (
            <Fragment>
                <div><b>How many people?:</b> {props.request.fitting_how_many_people}</div>
                <div><b>What type of apparels?:</b> {apparelTypes.join(', ')}</div>
                <div><b>What Style/Fit?:</b> {styles.join(', ')}</div>
                {address}
            </Fragment>
        );
    };

    let actions = [
        <button key="save-button" className="btn btn-light btn-sm action-button" onClick={props.sendResponse} disabled={props.sending}>{buttonLabel}</button>,
        <button key="close-button" className="btn btn-light btn-sm action-button" onClick={props.closeTicket} disabled={props.closingTicket}>{closeButtonLabel}</button>,
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Cancel</button>
    ];
    return (
        <Dialog
            name="help-desk-form-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="admin-help-desk-form-modal-dialog"
        >
            <div className="admin-help-desk-form-modal-container">
                <div className="title">Help Desk Request</div>
                <div className="information-container">
                    <div><b>Date:</b> {dateToTimezone(props.request.created_at, 'MM/DD/YYYY')}</div>
                    <div><b>Ticket ID:</b> {props.request.id}</div>
                    <div><b>Client Name:</b> {props.request.name}</div>
                    <div><b>Email:</b> {props.request.email}</div>
                    <div><b>Team:</b> {props.request.team_name}</div>
                    <div><b>Help With:</b> {props.request.help_with}</div>
                    <div><b>Coupa PO#:</b> {props.request.coupa_po}</div>
                    <div><b>Order ID:</b> {props.request.order_id}</div>
                    {renderFittingInformation()}
                    <div><b>Client Message:</b> {props.request.message}</div>
                    {renderFiles()}
                </div>
                <div className="log-container">
                    <div className="log-title">
                        <div>Help Log:</div>
                        <div>Status: {status}</div>
                    </div>
                    <div className="log-list">{renderLog()}</div>
                    <div className="message-container">
                        <b>Response:</b>
                        <textarea placeholder="Enter a response message." value={props.responseMessage} onChange={handleSetResponseMessage} />
                    </div>
                </div>
            </div>
        </Dialog >
    );
});

export default FormModal;
